import * as CryptoJS from 'crypto-js';
function decryptOpenSSL(encryptedDataWithIv: string, password: string): string {
try {   
const bytes = CryptoJS.AES.decrypt(encryptedDataWithIv, password);
const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

  if (!decryptedData) {
    throw new Error('Decryption failed, resulting in an empty string');
  }

    return decryptedData;
} catch (error) {
  console.error('Error decrypting data:', error);
  return '';
}
}

export { decryptOpenSSL };